(function($) {

  var app = {};

  app.validateForm = function() {

    var validatorForm = {
      config: { // Classi di configurazione del validatorForme!
        'nextStep': '.next-step',
        'tab-container': '.tab-container'
      },
      current_step: false, // Step attuale della form.
      steps: [], // Contenitore dei singoli step (definito piÃ¹ avanti. [nell'init -> ])
      /*
      Il metodo viene richiamato in due casi:
      - Link sul contenitore delle etichette delle tab
      - Click sul tasto Prossimo Step!
      !! il changeStep viene richiamato sempre dopo essere sicuri che Ã¨ possibile andare allo step successivo
       */
      changeStep: function(step) {

        $(".tab-content-form[data-index='" + this.current_step + "']").removeClass('active, show ').hide(); // Nascondiamo lo step corrente.
        $(".tab-content-form[data-index='" + step + "']").addClass('active, show').show(); // Mostriamo lo step richiesto
        $(".nav-link").removeClass('active');
        $(".nav-link[data-index='" + step + "']").addClass('active');
        this.current_step = step; // Impostiamo lo step richiesto come step corrente
        this.validateForm(); // Rilanciamo la Validazione.
      },
      /*
      Il metodo abilita il tasto (e il link) per andare allo step successivo (o a un altro step.)
       */
      enableStep: function(step) {
        // Controllo che lo step da abilitare esista, altrimenti mostro il button di invio della form.
        if (step >= this.totSteps()) {

          $('button[type="submit"]').show(); // Mostro il submit dell'intera form.
          return false;
        }
        // Se arrivo qui, invece, devo cambiare il dom, per abilitare i tasti...
        $('.step').eq(step).removeClass('disabled');
        $(validatorForm.config.nextStep).show();
        $('.next-step code').html(step);
        // prima, distruggo tutti gli eventuali eventi sul click (altrimenti compare N volte). E poi bindo un solo click.
        $(validatorForm.config.nextStep).off('click').one('click', function() {
          validatorForm.changeStep(step);
        });
      },
      /*
      Questo metodo invece disabilita lo step.
       */
      disableStep: function(step) {

        //if(step >= this.totSteps()) return;
        $('.step').eq(step).addClass('disabled');
        $(validatorForm.config.nextStep).hide().off('click');


      },

      /* Restituisce il numero totale degli step. */
      totSteps: function() {
        return this.steps.length;
      },

      /* Questa Ã¨ la funzione principale, che da il permesso o meno per procedere con gli step successivi (in base al this.current_step) */
      validateForm: function() {

        var fieldToCheck = this.steps[this.current_step].fields; // Prendiamo solo i field dello step corrente.
        var nextStep = true; // per comoditÃ , partiamo con l'idea che si puÃ² procedere al prossimo step. (poi controlleremo i singoli field.)
        //console.log(fieldToCheck);

        // Cicliamo tutti i field e, se hanno valore false (il campo ha valore false, se il singolo campo Ã¨ non valido (ma puÃ² comunque avere un valore)) invalidiamo la validazione.....
        for (var i in fieldToCheck) {
          console.log(typeof fieldToCheck[i]);
          if (fieldToCheck[i] === false)
            nextStep = false;
						//Abilito l'alert quando nextStep è False
						$('.alertCompila').show();

        }
        console.log(nextStep);

        if (nextStep == true) {
          this.enableStep(this.current_step + 1); // abilito lo step successivo.
					//rimuovo l'alert
					$('.alertCompila').hide();
          //abilito lo scrolltop al pulsante dello step
          $(".next-step").click(function() {
            $('html, body').animate({
              scrollTop: $("#anchor").offset().top
            }, 1000);
          });
          return [this.current_step, true]; // ritorno un vettore, in prima posizione lo step corrente, in seconda l'esito della validazione.

        } else {
          this.disableStep(this.current_step + 1);
          return [this.current_step, false];

        }

      },

      /* Funzione di creazione del form validatorForm */
      init: function() {

        // 1) Cerco tutti i campi che hanno i required, divisi per step/tab
        $('.tab-content-form').each(function(index) {

          // Imposto il data-index (per tenere traccia dell'indice della tab.)
          $(this).attr('data-index', index);

          //
          $('.tab-links li a').eq(index) // Prendo il corrispettivo LINK in base alla tab corrente.
            .attr('data-index', index) // Imposto l'indice
            .on('click', function() { // Creo la funzione che permetterÃ  di cambiare la tab.

              var validation_current_tab = validatorForm.validateForm(); // Prendo lo stato attuale di validazione della tab

              // Controlliamo che: la tab corrente sia valida, l'indice sia della tab successiva, OPPURE che sia inferiore (se Ã¨ inferiore puoi sempre andarci.)
              if ((validation_current_tab[1] != false && index == validation_current_tab[0] + 1) || index < validatorForm.current_step)
                validatorForm.changeStep(index); // Cambio la tab, perchÃ© le condizioni sono vere.
            });

          // Creo l'oggetto temporaneo con i field che vorrÃ² validare.
          var step = {
            step: index,
            fields: {}
          };

          // Ciclo solo i field che sono REQUIRED (html5)
          $('[required]', this).each(function() {

            var name = $(this).attr('name');

            step.fields[name] = $(this).val() || false; // !! questo Ã¨ come l'operatore elvis!

          }).on('keyup change', function() { // Aggiugno al KeyUp di ogni field Required, la funzione che ne controlla la validitÃ .

            var step = $(this).parent('.tab-content-form').attr('data-index');
            var name = $(this).attr('name');
            var valore = $(this).val();

            if (name == 'cf') {
              $('.alertcf').remove();
              if (valore.match(/^[A-Za-z]{6}[0-9]{2}[A-Za-z]{1}[0-9]{2}[A-Za-z]{1}[0-9]{3}[A-Za-z]{1}$/))
                validatorForm.steps[index].fields[name] = valore;
              else {
                validatorForm.steps[index].fields[name] = false;
                //alert('Inserire codice fiscale corretto').off();
                $('input#cf').closest('div').append('<div class="alertcf">Inserire codice fiscale corretto</div>').css('color', 'red');

                $('#cf').append("<p>Inserire codice fiscale corretto</p>");
              }
            }	else if (name == 'pivaCf') {
              $('.alertpivaCf').remove();
              if (valore.match(/^[0-9]{11}$/) || valore.match(/^[A-Za-z]{6}[0-9]{2}[A-Za-z]{1}[0-9]{2}[A-Za-z]{1}[0-9]{3}[A-Za-z]{1}$/))
                validatorForm.steps[index].fields[name] = valore;
              else {
                validatorForm.steps[index].fields[name] = false;
                $('input#pivaCf').closest('div').append('<div class="alertpivaCf">Inserire CF o PI corretto</div>').css('color', 'red');
              }
            }
						else if (name == 'pivaCf') {
              $('.alertpivaCf').remove();
              if (valore.match(/^[0-9]{11}$/) || valore.match(/^[A-Za-z]{6}[0-9]{2}[A-Za-z]{1}[0-9]{2}[A-Za-z]{1}[0-9]{3}[A-Za-z]{1}$/))
                validatorForm.steps[index].fields[name] = valore;
              else {
                validatorForm.steps[index].fields[name] = false;
                $('input#pivaCf').closest('div').append('<div class="alertpivaCf">Inserire CF o PI corretto</div>').css('color', 'red');
              }
            } else if (name == 'cap') {
              $('.alertpivaCf').remove();
              if (valore.match(/^[0-9]*\d$/))
                validatorForm.steps[index].fields[name] = valore;
              else {
                validatorForm.steps[index].fields[name] = false;
                $('input#cap').closest('div').append('<div class="alertpivaCf">Iserire Cap valido</div>').css('color', 'red');
              }
            }
            else if (name == 'cellulare') {
              $('.alertpivaCf').remove();
              if (valore.match(/^[0-9]*\d$/))
                validatorForm.steps[index].fields[name] = valore;
              else {
                validatorForm.steps[index].fields[name] = false;
                $('input#cellulare').closest('div').append('<div class="alertpivaCf">Iserire numero valido</div>').css('color', 'red');
              }
            }
            else if (name == 'telefonofisso') {
              $('.alertpivaCf').remove();
              if (valore.match(/^[0-9]*\d$/))
                validatorForm.steps[index].fields[name] = valore;
              else {
                validatorForm.steps[index].fields[name] = false;
                $('input#telFisso').closest('div').append('<div class="alertpivaCf">Iserire numero valido</div>').css('color', 'red');
              }
            }
            else if (name == 'piva') {
              $('.alertpiva').remove();
              if (valore.match(/^[0-9]{11}$/))
                validatorForm.steps[index].fields[name] = valore;
              else {
                validatorForm.steps[index].fields[name] = false;
                //alert('Inserire partita iva corretta').off();
                $('input#piva').closest('div').append('<div class="alertpiva">Inserire partita iva corretta</div>').css('color', 'red');
              }
            } else if (name == 'emailAnag') {
              $('.alertemailAnag').remove();
              if (valore.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/))
                validatorForm.steps[index].fields[name] = valore;
              else {
                validatorForm.steps[index].fields[name] = false;
                //alert('Inserire email corretta').off();
                $('input#emailAnag').closest('div').append('<div class="alertemailAnag">Inserire email corretta</div>').css('color', 'red');

              }
            } else if (name == 'emailAnagSec') {
              $('.alertemailAnagSec').remove();
              if (valore.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/))
                validatorForm.steps[index].fields[name] = valore;
              else {
                validatorForm.steps[index].fields[name] = false;
                //alert('Inserire email corretta').off();
                $('input#emailAnagSec').closest('div').append('<div class="alertemailAnagSec">Inserire email corretta</div>').css('color', 'red');
              }
            } else if (name == 'emailPerm') {
              $('.alertemailPerm').remove();
              if (valore.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/))
                validatorForm.steps[index].fields[name] = valore;
              else {
                validatorForm.steps[index].fields[name] = false;
                //alert('Inserire email corretta').off();
                $('input#emailPerm').closest('div').append('<div class="alertemailPerm">Inserire email corretta</div>').css('color', 'red');
              }
            } else {
              validatorForm.steps[index].fields[name] = valore || false;
            }
            // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
            // Qui, tutta l'eventuale logica di validazione dei singoli campi... (<input... validatorForm="piva">..) $(this).attr('validatorForm') == 'piva' => -...

            // Se il field ha un valore, allora viene impostato nell'oggetto che contiene tutti i valori (divisi per step), sennÃ² FALSE (il false ivalida lo step.)
            //  validatorForm.steps[index].fields[name] = valore || false;
            validatorForm.validateForm(); // Lancio la validazione.
            console.log(validatorForm);
          });

          validatorForm.steps[index] = step; // Riempio il contenitore degli step con lo step attuale.

        });

        // 2) Setto i listner
        // 3) La funzione che valida/invalida.

        var firstTab = parseInt($('.tab-content-form').eq(0).show().attr('data-index')); // Do per scontato che la prima tab sia la prima da vedere.
        validatorForm.current_step = firstTab;
        // console.log(firstTab);

        $('input[type="submit"]').hide(); // Nascondiamo il submit perchÃ© verrÃ  abilitato all'ultimo step.

      }

    };

    validatorForm.init(); // Avvio l'intero meccanismo di validazione!!
    $(document).on('needToRestartValdator', function() {
      validatorForm.init();
    });
    //   console.log(validatorForm);
  };
  app.validateForm();
  // $(document).ready( function () {
  //   $('#marcaveicolo').trigger('change');
  //   $('#Carrozzeria').trigger('change');
  //
  // });
})(jQuery);
